import { render, staticRenderFns } from "./SettingsBotAddMarketEditor.vue?vue&type=template&id=4944c1b7&"
import script from "./SettingsBotAddMarketEditor.vue?vue&type=script&lang=js&"
export * from "./SettingsBotAddMarketEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports